import { jsx as _jsx } from "react/jsx-runtime";
import { createRichTextComponentNode, RichTextNodeType, } from '@dossierhq/core';
import { BlockWithAlignableContents } from '@lexical/react/LexicalBlockWithAlignableContents.js';
import { DecoratorBlockNode } from '@lexical/react/LexicalDecoratorBlockNode.js';
import { useContext } from 'react';
import { PublishedDossierContext } from '../../contexts/PublishedDossierContext.js';
import { ComponentFieldDisplay } from '../EntityDisplay/ComponentFieldDisplay.js';
import { RichTextDisplayContext } from './RichTextDisplayContext.js';
function $createPublishedComponentNode(data) {
    return new PublishedComponentNode(data);
}
/** @public */
export function $isPublishedComponentNode(node) {
    return node instanceof PublishedComponentNode;
}
function PublishedComponentComponent({ className, format, nodeKey, data, }) {
    const { fieldSpec } = useContext(RichTextDisplayContext);
    const { adapter } = useContext(PublishedDossierContext);
    const overriddenDisplay = adapter.renderPublishedRichTextComponentDisplay({
        value: data,
    });
    return (_jsx(BlockWithAlignableContents, { className: className, format: format, nodeKey: nodeKey, children: overriddenDisplay ?? (_jsx(ComponentFieldDisplay, { className: "rich-text-item-indentation", fieldSpec: fieldSpec, value: data })) }));
}
export class PublishedComponentNode extends DecoratorBlockNode {
    __data;
    static getType() {
        return RichTextNodeType.component;
    }
    static clone(node) {
        return new PublishedComponentNode(node.__data, node.__format, node.__key);
    }
    constructor(data, format, key) {
        super(format, key);
        this.__data = data;
    }
    setData(data) {
        const self = this.getWritable();
        self.__data = data;
    }
    getData() {
        const self = this.getLatest();
        return self.__data;
    }
    static importJSON(serializedNode) {
        const node = $createPublishedComponentNode(serializedNode.data);
        node.setFormat(serializedNode.format);
        return node;
    }
    exportJSON() {
        //TODO format
        return createRichTextComponentNode(this.__data);
    }
    createDOM() {
        const div = document.createElement('div');
        div.style.display = 'contents';
        return div;
    }
    getTextContent() {
        return '\n';
    }
    decorate(_editor, config) {
        const embedBlockTheme = config.theme.embedBlock || {};
        const className = {
            base: embedBlockTheme.base || '',
            focus: embedBlockTheme.focus || '',
        };
        return (_jsx(PublishedComponentComponent, { className: className, data: this.__data, format: this.__format, nodeKey: this.__key }));
    }
}
//# sourceMappingURL=PublishedComponentNode.js.map